import { useEffect, useState } from "react";
import { CalendarClock } from "lucide-react";

const left = (day) => {
  const ms = new Date(`${day}T00:00:00`).getTime() - Date.now();
  return ms <= 0 ? null : { days: Math.floor(ms / 864e5), hours: Math.floor((ms % 864e5) / 36e5), mins: Math.floor((ms % 36e5) / 6e4) };
};

export const ElectionCountdown = ({ election, country, action }) => {
  const [t, setT] = useState(() => (election?.date ? left(election.date) : null));
  useEffect(() => {
    if (!election?.date) return undefined;
    const i = setInterval(() => setT(left(election.date)), 30000);
    return () => clearInterval(i);
  }, [election?.date]);
  if (!election?.date && !election?.due) return action ? <div className="flex justify-end" data-testid="election-countdown-empty">{action}</div> : null;
  const when = election.date ? new Date(`${election.date}T00:00:00`).toLocaleDateString(undefined, { day: "numeric", month: "long", year: "numeric" }) : "";
  return (
    <div className="flex flex-wrap items-center gap-x-4 gap-y-2 rounded-2xl border border-border bg-white px-4 py-3" data-testid="election-countdown">
      <CalendarClock size={20} className="shrink-0 text-[hsl(var(--facts))]" />
      <div className="min-w-[9rem] flex-1">
        <p className="text-[11px] font-semibold uppercase tracking-wider text-slate-500">Next {country} election</p>
        <p className="text-sm font-medium text-slate-900" data-testid="election-countdown-date">{election.date ? when : election.due}</p>
      </div>
      {election.date && t && (
        <div className="flex gap-3 font-serif" data-testid="election-countdown-timer">
          {[["days", t.days], ["hours", t.hours], ["mins", t.mins]].map(([l, v]) => (
            <span key={l} className="text-center"><span className="block text-2xl leading-none">{v}</span><span className="block font-sans text-[10px] uppercase tracking-wider text-slate-500">{l}</span></span>
          ))}
        </div>
      )}
      {election.date && !t && <span className="rounded-full bg-rose-600 px-3 py-1 text-xs font-bold uppercase tracking-wider text-white" data-testid="election-countdown-today">Election day</span>}
      {!election.date && <span className="text-xs text-slate-500" data-testid="election-countdown-unset">The countdown starts once the date is officially set</span>}
      {action}
    </div>
  );
};
